import currentAcademicInstitution from './academicInstitutions.js.erb';

const updateConsentCopy = (form) => {
  var academicInstitution = currentAcademicInstitution();
  var agreeLabel = form.querySelector('.js-custom-form__contact-checkbox-block label');
  var submitButton = form.querySelector('input[type=submit]');
  var privacyText = form.parentNode.querySelector('.privacy-text');
  if (privacyText) { privacyText.classList.add('hidden'); }

  var policyLink = document.createElement('a');
  var policyLinkText = document.createTextNode('Privacy Policy');
  policyLink.href = 'https://emeritus.org/privacy-policy/';
  policyLink.target = '_blank';
  policyLink.appendChild(policyLinkText);

  agreeLabel.innerHTML = `
    <p class='paragraph paragraph--xsmall margin-bottom-none'>I agree to receive communications from ${academicInstitution.nickname} & Emeritus
    about this program and other relevant programs.
    ${policyLink.outerHTML}
    </p>
  `;

  var implicitParagraph = document.createElement('p');
  var implicitText = document.createTextNode(`
    By clicking the button below, you agree to receive communications from
    ${academicInstitution.nickname} & Emeritus about this program and other relevant programs.
  `);
  implicitParagraph.classList.add('js-implicit-consent', 'paragraph', 'paragraph--xsmall', 'margin-bottom-small');
  implicitParagraph.appendChild(implicitText);
  implicitParagraph.appendChild(policyLink);

  form.insertBefore(implicitParagraph, submitButton);
};

export default updateConsentCopy;
